import { get } from '@/lib/api-client';
import type {
  LeaderboardResponse,
  UserStatsResponse,
  LeaderboardScope,
  LeaderboardPeriod
} from 'shared-types';

interface LeaderboardParams {
  period?: LeaderboardPeriod;
  scope?: LeaderboardScope;
  country?: string;
  page?: number;
  limit?: number;
}

function buildQueryString(params: LeaderboardParams): string {
  const searchParams = new URLSearchParams();
  if (params.period) searchParams.set('period', params.period);
  if (params.scope) searchParams.set('scope', params.scope);
  if (params.country) searchParams.set('country', params.country);
  if (params.page) searchParams.set('page', String(params.page));
  if (params.limit) searchParams.set('limit', String(params.limit));
  const qs = searchParams.toString();
  return qs ? `?${qs}` : '';
}

export const leaderboardApi = {
  getUserStats: async (params: LeaderboardParams = {}): Promise<UserStatsResponse> => {
    return get<UserStatsResponse>(`/leaderboard/user-stats${buildQueryString(params)}`);
  },

  getLeaderboard: async (params: LeaderboardParams = {}): Promise<LeaderboardResponse> => {
    return get<LeaderboardResponse>(`/leaderboard${buildQueryString(params)}`);
  }
};
